import {
    SetupDataStore,
    PrequalificationResponseStore,
    getSoftPrequalContinuationId,
} from '@servicetitan/financing-workflow-shared';
import { useEffect } from 'react';

export const TransitionToHardApp = ({ onCompleted }: { onCompleted: () => void }) => {
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { prequalificationResponse } = PrequalificationResponseStore.useStore();
    // Boolean so a successful write (which replaces the setup-data object) does not re-run this
    // effect and call onCompleted again.
    const hasSetupData = setupData != null;

    useEffect(() => {
        const response = prequalificationResponse;
        const continuationId = getSoftPrequalContinuationId(response);
        if (!response || !continuationId || !hasSetupData) {
            return;
        }

        // The prequals service returns its own prequal id; the financing soft-pull endpoint returns
        // the loan row the hard submit reuses. Only the former may be written as
        // prequalificationId — it selects the prequal provider config and workflow renderer.
        const usesPrequalsServiceId = 'prequalId' in response && !!response.prequalId;

        // Functional update: the caller sets hasTransitionedToHardApp in the same batch that routes
        // here, so writing a render-time snapshot back would drop the flag and leave every
        // soft-vs-hard decision (provider config, headings, submit label, disclosures) on the
        // prequalification. Setting it here too keeps the transition correct regardless of caller.
        setSetupData(previous =>
            previous
                ? {
                      ...previous,
                      hasTransitionedToHardApp: true,
                      isApplyingForPrequalification: false,
                      ...(usesPrequalsServiceId
                          ? { prequalificationId: continuationId }
                          : { loanId: continuationId }),
                  }
                : previous,
        );
        onCompleted();
    }, [prequalificationResponse, onCompleted, setSetupData, hasSetupData]);

    return null;
};
